<button mat-raised-button color="primary" *appRole="['Movimientos.Crear']" (click)="openDialogCreateMovimiento()">
  <mat-icon>add</mat-icon>
  Nuevo movimiento
</button>
